






























































































import { defineComponent, computed, PropType, ref, onMounted, watch } from "@vue/composition-api";
import { useActions,useGetters, useMutations, useState } from "vuex-composition-helpers";
import { IPortalSubtopicRelatedPagesWidgetModel, IPortalSubtopicContactWidgetModel, IPortalSubtopicContactWidgetLabels } from "@/apps/PortalSubtopicAsideWidget/models/PortalSubtopicAside-widget-state";

export default defineComponent({
  name: "PortalSubtopicAsideWidget",
  props: {
    relatedPages: {type: Array as PropType<IPortalSubtopicRelatedPagesWidgetModel[]>, required: true},
    contactInformation: {type: Array as PropType<IPortalSubtopicContactWidgetModel[]>, required: true},
    labels: {type: Object as PropType<IPortalSubtopicContactWidgetLabels>, required: true}
  },
  setup: (props) => {
    const {init} = useActions(['init'])
    const {relatedPagesFromStore} = useGetters(['getRelatedPages'])
    const {contactInformationFromStore} = useGetters(['getContactInformation'])

    const {selectedFaculty} = useState(['selectedFaculty'])
    const {associatedRelatedPages} = useState(['associatedRelatedPages'])
    const {associatedContactInfo} = useState(['associatedContactInfo'])

    const relatedPages = ref(props.relatedPages || relatedPagesFromStore.value);
    const contactInformation = ref(props.contactInformation || contactInformationFromStore.value);

    const { setSelectedFaculty } = useMutations(['setSelectedFaculty'])

    const distinctFaculties = computed(() => {
      const allFaculties = [
        ...relatedPages.value.flatMap((p: IPortalSubtopicRelatedPagesWidgetModel) => p.faculties),
        ...contactInformation.value.flatMap((c: IPortalSubtopicContactWidgetModel) => c.faculties)
      ];
      return Array.from(new Set(allFaculties));
    });

    const generalRelatedPages = computed(() => {
      return relatedPages.value.filter((p: IPortalSubtopicRelatedPagesWidgetModel) => !p.faculties.length);
    });

    const generalContact = computed(() => {
      return contactInformation.value.find((c: IPortalSubtopicContactWidgetModel) => !c.faculties.length) || null;
    });

    const hasGeneralRelatedPages = computed(() => {
      return generalRelatedPages.value.length > 0;
    });

    const hasSpecificRelatedPages = computed(() => {
      return relatedPages.value.some((p: IPortalSubtopicRelatedPagesWidgetModel) => p.faculties.length);
    });

    const hasGeneralContact = computed(() => {
      return generalContact.value !== null;
    });

    const hasSpecificContact = computed(() => {
      return contactInformation.value.some((c: IPortalSubtopicContactWidgetModel) => c.faculties.length);
    });

    const shouldDisplay = computed(() => {
      return relatedPages.value.length || contactInformation.value.length;
    });

    onMounted(async () => {
      await init(props)

      if (localStorage.portalSelectedFaculty) {
        setSelectedFaculty(localStorage.portalSelectedFaculty)
      }

      watch(selectedFaculty, (value) => {
        localStorage.portalSelectedFaculty = value
      })
    })

    return {
      distinctFaculties,
      generalRelatedPages,
      generalContact,
      hasGeneralRelatedPages,
      hasSpecificRelatedPages,
      hasGeneralContact,
      hasSpecificContact,
      shouldDisplay,
      setSelectedFaculty,
      selectedFaculty,
      associatedRelatedPages,
      associatedContactInfo,
    };
  }
})
